// @flow

import { location, document } from 'window';
import url from 'url';

import $ from 'jquery';

function remoteToggle () {
	const { hash } = url.parse(location.href);

	if (!hash) {
		return;
	}

	const id = hash.slice(1);
	const element: HTMLElement = document.getElementById(id);

	if (!element) {
		return;
	}

	if (!element.hasAttribute('data-remote-toggle')) {
		return;
	}

	$(element).click();
}

module.exports = remoteToggle;
